"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = exports.setEnv = exports.isCI = exports.isProduction = exports.isStaging = exports.isTesting = exports.isDevelopment = void 0;
var __1 = require("..");
var check = function () {
    var d = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        d[_i] = arguments[_i];
    }
    var env = process.env.ENV === undefined || process.env.ENV === "undefined" ? "" : process.env.ENV;
    return d.some(function (data) { return env === data; });
};
var isDevelopment = function () {
    return check("development", "develop", "dev", "d", "");
};
exports.isDevelopment = isDevelopment;
var isTesting = function () {
    return check("testing", "tested", "test", "t");
};
exports.isTesting = isTesting;
var isStaging = function () {
    return check("staging", "stage", "stag", "s");
};
exports.isStaging = isStaging;
var isProduction = function () {
    return check("production", "product", "prod", "p");
};
exports.isProduction = isProduction;
var isCI = function () {
    return process.env.CI === "true";
};
exports.isCI = isCI;
var setEnv = function (name, value) {
    var old = process.env[name];
    process.env[name] = value;
    return old;
};
exports.setEnv = setEnv;
var read = function (name, def) {
    var env = process.env[name];
    if (__1.generic.isExist(env))
        return env;
    else
        return def;
};
exports.read = read;
//# sourceMappingURL=env.js.map